import React, { useState } from 'react';
import { withTranslation } from '../../ChildrenContext';
import { Link } from '../../RouterCompatibility';
import PropTypes from 'prop-types';
import runtimeConfig from '../../../config/runtimeConfig';

import { useTemplateConfig } from '../../../context/TemplateConfigContext';

const NotFoundPage = (props) => {
    const { assets } = useTemplateConfig();
    const [showCode, setShowCode] = useState(props.showCode);
    const [staticNames, setStaticNames] = useState(props.static);

    const finalStaticNames = staticNames || (props.t && props.t.errorPage && props.t.errorPage.notFound) || {};

    if(showCode) {
        return (
            <div>
                <a href="/" className="error-page__logo">
                    <img className="logo" src={assets.brand.logoExtended} alt=""/>
                </a>
                <div className="error-page__notfound text-center">
                    <img className="error-page__img" src={assets.icons.error404} alt=""/>
                    <h2 className="font-bold">{finalStaticNames.title}</h2>
                    <div className="error-desc">
                        {finalStaticNames.text}
                    <br/><br/>
                        <Link className="btn error-page__btn" to={`${runtimeConfig.defaultRoute}`}>{finalStaticNames.link}</Link>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="notfound text-center">
                <h3 className="font-bold">{finalStaticNames.title}</h3>
                <div className="error-desc">
                    {finalStaticNames.text}
                    <br />
                    <Link className="btn apply-btn" to={`${runtimeConfig.defaultRoute}`}>Dashboard</Link>
                </div>
            </div>
        );
    }
};

NotFoundPage.propTypes = {
    showCode: PropTypes.bool,
    t: PropTypes.object
};

NotFoundPage.defaultProps = {
    showCode: true
};

export default withTranslation(NotFoundPage);
